module.exports = __webpack_public_path__ + "static/media/tamu.7cd62295.svg";